"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPartnerModel = void 0;
const legacy_models_1 = require("@daytrip/legacy-models");
class ApiPartnerModel extends legacy_models_1.ApiPartner {
}
exports.ApiPartnerModel = ApiPartnerModel;
//# sourceMappingURL=api-partner.model.js.map